import React, {Component} from 'react';

export default class RadioGroup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedItems: this.props.items.filter(item => { return item.active })
    }
    this.selectItem = this.selectItem.bind(this);
    this.update = this.update.bind(this);
  }

  update() {
    this.setState({
      selectedItems: this.props.items.filter(item => { return item.active })
    });
  }

  selectItem(item) {
    if (item.inactive) return;
    let removeIndex = false;
    item.active = true;
    for(let i = 0; i < this.state.selectedItems.length; i++) {
      if (this.state.selectedItems[i].id === item.id) {
        item.active = false;
        removeIndex = i;
      }
    }

    if (removeIndex === false) this.state.selectedItems.push(item);
    else this.state.selectedItems.splice(removeIndex, 1);

    let selectedItems = this.state.selectedItems;
    if (!this.props.allowNull) {
        if (!this.state.selectedItems.length) {
            this.props.items.forEach(item => {
                item.active = true;
                selectedItems.push(item);
            })
        }
    }

    this.setState({selectedItem: selectedItems});
    this.props.getItem(selectedItems, item);
  }

  render() {
    let _self = this;
    return <div className={'c-radio-group'}>
      <span className={'c-radio-group-title'}>{this.props.text}</span>
      <ul className={'c-radio-group-options'}>
        {this.props.items.map((item, i) => {
          let style = {};
          if (item.color && item.color.indexOf('#') >= 0) style = { background: item.color };
          return <li className={'c-radio-group-options-item ' + (item.inactive ? 'inactive ' : '')} onClick={() => { _self.selectItem(item) }} data-id={item.id} key={i}>
            <i className={'c-radio-group-options-item-circle ' + (item.active ? ' active ' : '') + (item.color && item.color.indexOf('#') === -1 ? item.color : '')}>
              <i style={style}></i>
            </i>
            <span className="c-radioo-group-options-item-label">{item.label}</span>
          </li>
        })}
      </ul>
    </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/base/radiogroup.js